"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9129],{

/***/ 90331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HR": function() { return /* binding */ IMAGE_SHAPE_OVERRIDING_GLOBAL_STYLE; },
/* harmony export */   "JH": function() { return /* binding */ getCardConfigurations; },
/* harmony export */   "WR": function() { return /* binding */ getCurrentClass; },
/* harmony export */   "bR": function() { return /* binding */ getOverlayWrapperStyles; },
/* harmony export */   "cw": function() { return /* binding */ getShapeStyles; },
/* harmony export */   "wo": function() { return /* binding */ getTextContainerStyles; },
/* harmony export */   "z4": function() { return /* binding */ getOverlayTextStyles; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91850);


var IMAGE_SHAPE_OVERRIDING_GLOBAL_STYLE = [
    "circle",
    "arch",
    "blob"
];
var getShapeStyles = function(cardShape) {
    var cardWidth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, isFullWidthImgInCard = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    switch(cardShape){
        case "circle":
            return [
                {
                    className: "!tw-rounded-[50%]",
                    style: {}
                }
            ];
        case "arch":
            return [
                {
                    className: "!tw-rounded-es-[0px] !tw-rounded-ee-[0px]",
                    style: {
                        borderStartStartRadius: cardWidth ? "".concat(cardWidth / 2, "px") : "50%",
                        borderStartEndRadius: cardWidth ? "".concat(cardWidth / 2, "px") : "50%"
                    }
                }, 
            ];
        case "blob":
            return [
                {
                    className: "!tw-rounded-[30%_70%_70%_30%_/_30%_47%_53%_70%]"
                },
                {
                    className: "!tw-rounded-[54%_46%_70%_30%_/_19%_79%_21%_81%]"
                },
                {
                    className: "!tw-rounded-[87%_13%_60%_40%_/_30%_93%_7%_70%]"
                },
                {
                    className: "!tw-rounded-[67%_33%_16%_84%_/_63%_52%_48%_37%]"
                },
                {
                    className: "!tw-rounded-[72%_28%_69%_31%_/_67%_57%_43%_33%]"
                }, 
            ];
        default:
            return [
                {
                    className: isFullWidthImgInCard ? "tw-rounded-es-[0px] tw-rounded-ee-[0px]" : "",
                    style: {}
                }, 
            ];
    }
};
var getCurrentClass = function(type) {
    switch(type){
        case "zoomInCard":
        case "zoomIn":
            return "zoomInOnHover";
        case "ambient":
            return "ambientOnHover";
        case "shadow":
            return "containerShadow";
        default:
            return "";
    }
};
var getOverlayWrapperStyles = function(configData) {
    var isTextNameBelow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref;
    var ref1 = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.cloneDeep)((configData === null || configData === void 0 ? void 0 : (ref = configData.contentConfig) === null || ref === void 0 ? void 0 : ref.textConfig) || {}), xAlignment = ref1.xAlignment, yAlignment = ref1.yAlignment, overlayOpacity = ref1.overlayOpacity;
    var styles = {
        justifyContent: "",
        alignItems: "",
        background: isTextNameBelow ? "" : "rgba(0,0,0,".concat(overlayOpacity / 100, ")")
    };
    switch(yAlignment){
        case "top":
            styles.justifyContent = "flex-start";
            break;
        case "middle":
            styles.justifyContent = "center";
            break;
        case "bottom":
            styles.justifyContent = "flex-end";
            break;
        default:
            styles.justifyContent = "flex-end";
            break;
    }
    switch(xAlignment){
        case "left":
            styles.alignItems = "flex-start";
            break;
        case "center":
            styles.alignItems = "center";
            break;
        case "right":
            styles.alignItems = "flex-end";
            break;
        default:
            styles.alignItems = "flex-end";
            break;
    }
    return styles;
};
var getTextContainerStyles = function(configData) {
    var ref;
    var xAlignment = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.cloneDeep)((configData === null || configData === void 0 ? void 0 : (ref = configData.contentConfig) === null || ref === void 0 ? void 0 : ref.textConfig) || {}).xAlignment;
    var styles = {
        justifyContent: "flex-start"
    };
    var className = "";
    switch(xAlignment){
        case "left":
            className = "!tw-justify-start";
            break;
        case "center":
            className = "!tw-justify-center";
            break;
        case "right":
            className = "!tw-justify-end";
            break;
    }
    return {
        styles: styles,
        className: className
    };
};
var getOverlayTextStyles = function(configData) {
    var buttonData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref;
    var ref1 = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.cloneDeep)((configData === null || configData === void 0 ? void 0 : (ref = configData.contentConfig) === null || ref === void 0 ? void 0 : ref.textConfig) || {}), textSize = ref1.textSize, textCase = ref1.textCase, colorScheme = ref1.colorScheme, textThicness = ref1.textThicness, xAlignment = ref1.xAlignment;
    var styles = {
        fontSize: "",
        textTransform: textCase,
        lineHeight: "1",
        color: colorScheme === null || colorScheme === void 0 ? void 0 : colorScheme.text,
        background: "",
        width: "auto",
        padding: "0px",
        textAlign: "unset",
        fontWeight: "400"
    };
    switch(xAlignment){
        case "left":
            styles.textAlign = "left";
            break;
        case "center":
            styles.textAlign = "center";
            break;
        case "right":
            styles.textAlign = "right";
            break;
    }
    // if (colorScheme.background) {
    //   (styles.background = colorScheme.background), (styles.width = '100%');
    //   styles.padding = '8px';
    //   styles.textAlign = 'center';
    // }
    switch(textSize){
        case "extraSmall":
            styles.fontSize = "12px";
            styles.lineHeight = "1";
            break;
        case "small":
            styles.fontSize = "14px";
            styles.lineHeight = "1";
            break;
        case "medium":
            styles.fontSize = "16px";
            styles.lineHeight = "1.2";
            break;
        case "large":
            styles.fontSize = "18px";
            styles.lineHeight = "1.2";
            break;
        case "extraLarge":
            styles.fontSize = "20px";
            styles.lineHeight = "1.2";
            break;
        default:
            styles.fontSize = "16px";
            styles.lineHeight = "1.1";
            break;
    }
    switch(textThicness){
        case "thin":
            styles.fontWeight = "300";
            break;
        case "regular":
            styles.fontWeight = "400";
            break;
        case "medium":
            styles.fontWeight = "500";
            break;
        case "bold":
            styles.fontWeight = "700";
            break;
        default:
            styles.fontWeight = "400";
            break;
    }
    if (buttonData && buttonData.type !== src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_1__/* .BUTTON_TYPE.TEXTUAL */ .JB.TEXTUAL) {
        styles.textAlign = "center";
    }
    return styles;
};
var getCardConfigurations = function(cardFrameConfig) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var isNonTextualElementPresent = ((ref2 = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref = cardFrameConfig.contentConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonConfig) === null || ref1 === void 0 ? void 0 : ref1.filter(function(item) {
        return item.isShow && item.type !== "textual";
    })) === null || ref2 === void 0 ? void 0 : ref2.length) || ((ref6 = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref3 = cardFrameConfig.contentConfig) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.textConfig) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.appearanceButton) === null || ref5 === void 0 ? void 0 : ref5.filter(function(item) {
        return item.isShow && item.type !== "textual";
    })) === null || ref6 === void 0 ? void 0 : ref6.length);
    // If no button layout was selected
    var isButtonLayout = (ref9 = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref7 = cardFrameConfig.contentConfig) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.buttonConfig) === null || ref8 === void 0 ? void 0 : ref8.filter(function(item) {
        return item.isShow;
    })) === null || ref9 === void 0 ? void 0 : ref9.length;
    var isTextNameBelow = (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref10 = cardFrameConfig.contentConfig) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.textConfig) === null || ref11 === void 0 ? void 0 : ref11.type) === "below";
    var isCollectionNameVisible = !!(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref12 = cardFrameConfig.contentConfig) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.textConfig) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.appearanceButton) === null || ref14 === void 0 ? void 0 : ref14.find(function(buttonData) {
        return buttonData.isShow;
    }));
    return {
        isNonTextualElementPresent: isNonTextualElementPresent,
        isButtonLayout: isButtonLayout,
        isTextNameBelow: isTextNameBelow,
        isCollectionNameVisible: isCollectionNameVisible
    };
};


/***/ }),

/***/ 18554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ useGetElementRects; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useGetElementRects(param) {
    var elementRef = param.elementRef;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        elementRect: {
            scrollWidth: 0,
            clientWidth: 0,
            clientHeight: 0
        },
        timeChanged: 0
    }), itemContainerLayoutChange = ref[0], setItemContainerLayoutChange = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (elementRef === null || elementRef === void 0 ? void 0 : elementRef.current) {
            var resizeObserverInst = new ResizeObserver(function() {
                var ref = (elementRef === null || elementRef === void 0 ? void 0 : elementRef.current) || {}, clientWidth = ref.clientWidth, scrollWidth = ref.scrollWidth, clientHeight = ref.clientHeight;
                setItemContainerLayoutChange({
                    elementRect: {
                        scrollWidth: scrollWidth,
                        clientWidth: clientWidth,
                        clientHeight: clientHeight
                    },
                    timeChanged: Date.now()
                });
            });
            (elementRef === null || elementRef === void 0 ? void 0 : elementRef.current) && resizeObserverInst.observe(elementRef === null || elementRef === void 0 ? void 0 : elementRef.current);
            return function() {
                return (elementRef === null || elementRef === void 0 ? void 0 : elementRef.current) && resizeObserverInst.unobserve(elementRef === null || elementRef === void 0 ? void 0 : elementRef.current);
            };
        }
    }, []);
    return [
        itemContainerLayoutChange
    ];
}


/***/ }),

/***/ 24200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$O": function() { return /* binding */ getShift; },
/* harmony export */   "F8": function() { return /* binding */ isLogoSliderAutoScroll; },
/* harmony export */   "JG": function() { return /* binding */ getRenderCardOverrides; },
/* harmony export */   "KH": function() { return /* binding */ getGridGapsForAxes; },
/* harmony export */   "KZ": function() { return /* binding */ getDisplayLabelStyles; },
/* harmony export */   "Ku": function() { return /* binding */ BLOG_SECTION_MAX_WIDTH; },
/* harmony export */   "Lw": function() { return /* binding */ getArrowMethods; },
/* harmony export */   "QO": function() { return /* binding */ isLogoSliderFullWidth; },
/* harmony export */   "Sk": function() { return /* binding */ INITIAL_SCROLL_PERCENTAGE; },
/* harmony export */   "Tf": function() { return /* binding */ getBlogData; },
/* harmony export */   "ZO": function() { return /* binding */ MAX_SECTION_WIDTH; },
/* harmony export */   "dE": function() { return /* binding */ getOneCellGeometry; },
/* harmony export */   "ns": function() { return /* binding */ onCarouselScroll; },
/* harmony export */   "qR": function() { return /* binding */ isTestimonialSliderFullWidth; },
/* harmony export */   "sR": function() { return /* binding */ getContainerTracks; }
/* harmony export */ });
/* unused harmony exports MAX_CARD_HEIGHT, MAX_CARD_WIDTH, MIN_CARD_WIDTH, MIN_CARD_HEIGHT, MAX_NUM_ROWS_DESKTOP, MAX_NUM_ROWS_MOBILE_ONE_COL, MAX_NUM_ROWS_MOBILE_TWO_COL, MULTI_COLUMN_MIN_WIDTH, MULTI_COLUMN_MIN_WIDTH_MOBILE, MIN_LOGO_SLIDER_CARD_WIDTH, MAX_PRODUCT_REEL_CARD_WIDTH_DESKTOP, MAX_PRODUCT_REEL_CARD_WIDTH_MOBILE, MIN_PRODUCT_REEL_CARD_WIDTH_DESKTOP, MIN_PRODUCT_REEL_CARD_WIDTH_MOBILE, MAX_PRODUCT_REEL_CARD_HEIGHT, MIN_PRODUCT_REEL_CARD_HEIGHT, MAX_LOGO_SLIDER_CARD_WIDTH, MAX_LOGO_SLIDER_HEIGHT, MIN_LOGO_SLIDER_HEIGHT, getCardFrameCustomStyle, getReelCardConfigs */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _CardFrameCollection_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90331);
/* harmony import */ var _components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16902);
/* harmony import */ var src_constants_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42381);







var MAX_SECTION_WIDTH = 1600;
var BLOG_SECTION_MAX_WIDTH = 1200;
var MAX_CARD_HEIGHT = 680;
var MAX_CARD_WIDTH = 680;
var MIN_CARD_WIDTH = 120; // 170; // 100;
var MIN_CARD_HEIGHT = 120; // 170; // 100;
var MAX_NUM_ROWS_DESKTOP = 2; // 170; // 100;
var MAX_NUM_ROWS_MOBILE_ONE_COL = 4;
var MAX_NUM_ROWS_MOBILE_TWO_COL = 6;
var INITIAL_SCROLL_PERCENTAGE = 20;
var MULTI_COLUMN_MIN_WIDTH = 150;
var MULTI_COLUMN_MIN_WIDTH_MOBILE = 100;
var MIN_LOGO_SLIDER_CARD_WIDTH = 50;
var MAX_PRODUCT_REEL_CARD_WIDTH_DESKTOP = 350;
var MAX_PRODUCT_REEL_CARD_WIDTH_MOBILE = 220;
var MIN_PRODUCT_REEL_CARD_WIDTH_DESKTOP = 172;
var MIN_PRODUCT_REEL_CARD_WIDTH_MOBILE = 150;
var MAX_PRODUCT_REEL_CARD_HEIGHT = 450;
var MIN_PRODUCT_REEL_CARD_HEIGHT = 250;
var MAX_LOGO_SLIDER_CARD_WIDTH = 160;
var MAX_LOGO_SLIDER_HEIGHT = 84;
var MIN_LOGO_SLIDER_HEIGHT = 50;
function getNumsOfColumn(isMobile, configData) {
    var ref = configData || {}, numColumnsDesktop = ref.numColumnsDesktop, numColumnsMobile = ref.numColumnsMobile, _mobileImagePosition = ref.mobileImagePosition, mobileImagePosition = _mobileImagePosition === void 0 ? "" : _mobileImagePosition;
    if ((configData === null || configData === void 0 ? void 0 : configData.type) === "blog") {
        return isMobile ? mobileImagePosition === "left" ? 1 : numColumnsMobile : numColumnsDesktop;
    }
    return isMobile ? numColumnsMobile : numColumnsDesktop;
}
// Returns number of columns
function getContainerTracks(param) {
    var isLayoutCarousel = param.isLayoutCarousel, itemCount = param.itemCount, isMobile = param.isMobile, listPresentationConfig = param.listPresentationConfig, _expandSelectedReel = param.expandSelectedReel, expandSelectedReel = _expandSelectedReel === void 0 ? false : _expandSelectedReel, _isTestimonials = param.isTestimonials, isTestimonials = _isTestimonials === void 0 ? false : _isTestimonials;
    var numColumnsOriginal = getNumsOfColumn(isMobile, listPresentationConfig);
    var numColumns = numColumnsOriginal;
    var numColumnsMax = itemCount < numColumns ? itemCount : numColumns;
    if (expandSelectedReel) {
        numColumns = 1;
    }
    // if (!useStaticNumColumns && itemCount < numColumns) {
    //   numColumns = itemCount;
    // }
    var numRowsForGrid = isMobile ? numColumns == 1 ? MAX_NUM_ROWS_MOBILE_ONE_COL : MAX_NUM_ROWS_MOBILE_TWO_COL : MAX_NUM_ROWS_DESKTOP;
    var numRows = isLayoutCarousel ? 1 : numRowsForGrid; // for grid -> 'auto', for carousel -> 1;
    if (numRows > itemCount / numColumns) {
        numRows = Math.ceil(itemCount / numColumns);
    }
    // if testimonial, grid -> max rows -> 2
    if (!isLayoutCarousel && isTestimonials) {
        numRows = Math.min(2, Math.ceil(itemCount / numColumns));
    }
    return {
        numColumns: numColumns,
        numRows: numRows,
        numColumnsOriginal: numColumnsOriginal,
        numColumnsMax: numColumnsMax
    };
}
function getCardMinMaxWidth(type, isMobile, forType) {
    switch(type){
        case "icon":
        case "image":
            return forType === "max" ? MAX_CARD_WIDTH : isMobile ? MULTI_COLUMN_MIN_WIDTH_MOBILE : MULTI_COLUMN_MIN_WIDTH;
        case "logoSlider":
            return forType === "max" ? MAX_LOGO_SLIDER_CARD_WIDTH : MIN_LOGO_SLIDER_CARD_WIDTH;
        case "featuredReels":
            return forType === "max" ? !isMobile ? MAX_PRODUCT_REEL_CARD_WIDTH_DESKTOP : MAX_PRODUCT_REEL_CARD_WIDTH_MOBILE : !isMobile ? MIN_PRODUCT_REEL_CARD_WIDTH_DESKTOP : MIN_PRODUCT_REEL_CARD_WIDTH_MOBILE;
        case "testimonials":
            return -1;
        default:
            return forType === "max" ? MAX_CARD_WIDTH : MIN_CARD_WIDTH;
    }
}
function getMaxHeight(type) {
    switch(type){
        case "logoSlider":
            return MAX_LOGO_SLIDER_HEIGHT;
        case "featuredReels":
            return MAX_PRODUCT_REEL_CARD_HEIGHT;
        default:
            return MAX_CARD_HEIGHT;
    }
}
// Width for each column (product item)
function getOneCellGeometry(param) {
    var cardContainerWidthForEachCell = param.cardContainerWidthForEachCell, containerTracks = param.containerTracks, aspectRatio = param.aspectRatio, widthAdditionals = param.widthAdditionals, type = param.type, isMobile = param.isMobile, isLayoutTypeCard = param.isLayoutTypeCard;
    var width = cardContainerWidthForEachCell / containerTracks.numColumns;
    // Reduce width slightly for each card so that an overflowed card is shown slightly to nudge the user to scroll
    width = width + widthAdditionals;
    var minWidth = getCardMinMaxWidth(type, isMobile, "min");
    var maxWidth = getCardMinMaxWidth(type, isMobile, "max");
    if (width > maxWidth && maxWidth > 0) width = maxWidth;
    if (width < minWidth && minWidth > 0) width = minWidth;
    // extract aspect ratio
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(aspectRatio.split(":").map(function(item) {
        return +item;
    }), 2), widthRatio = ref[0], heightRatio = ref[1];
    // calculate height
    var height = width * (heightRatio / widthRatio);
    if (height > getMaxHeight(type)) {
        height = getMaxHeight(type);
        width = ![
            "logoSlider",
            "testimonials"
        ].includes(type) ? height * (widthRatio / heightRatio) : width;
    }
    // Meanwhile the width will be used to calculate the normal layout related things because the card will achieve the width
    // as calculated because in case of card layout border width will get added
    return {
        width: width,
        height: height,
        itemWidth: isLayoutTypeCard ? width - 2 // remove horizontal border width as border wil be applied to child of 1px
         : width
    };
}
function getDisplayLabelStyles(configData) {
    var textAlign = configData === null || configData === void 0 ? void 0 : configData.textAlign;
    var styles = {
        alignItems: "",
        width: "100%"
    };
    switch(textAlign){
        case "left":
            styles.alignItems = "flex-start";
            break;
        case "center":
            styles.alignItems = "center";
            break;
        default:
            styles.alignItems = "center";
            break;
    }
    return styles;
}
function onCarouselScroll(param) {
    var e = param.e, setCarouselIndicatorConfigs = param.setCarouselIndicatorConfigs, _slideOffset = param.slideOffset, slideOffset = _slideOffset === void 0 ? 0 : _slideOffset, _widthOffset = param.widthOffset, widthOffset = _widthOffset === void 0 ? 0 : _widthOffset;
    var sectionViewportWidth = Math.floor(e.currentTarget.clientWidth);
    var sectionScrollWidth = Math.floor(e.currentTarget.scrollWidth);
    var currentScrollPosition = Math.floor(e.currentTarget.scrollLeft);
    var scrollPercent = currentScrollPosition / (sectionScrollWidth - sectionViewportWidth) * 100;
    // INITIAL_SCROLL_PERCENTAGE move advantage given
    var offsetPosition = scrollPercent * (INITIAL_SCROLL_PERCENTAGE / 100);
    // const currentFocusedSectionItem = Math.ceil(
    //   (currentScrollPosition + sectionViewportWidth) / sectionViewportWidth
    // );
    var currentFocusedSectionItem = Math.ceil(currentScrollPosition / (slideOffset - widthOffset)) + 1; // As this starts with 1 already
    setCarouselIndicatorConfigs(function(data) {
        var newScrollPercentage = Math.ceil(scrollPercent - offsetPosition + INITIAL_SCROLL_PERCENTAGE);
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, data), {
            direction: newScrollPercentage >= data.scrollPercentage ? "to-right" : "to-left",
            scrollPercentage: newScrollPercentage,
            currentFocusedSectionItem: Math.ceil(newScrollPercentage) === INITIAL_SCROLL_PERCENTAGE || Math.floor(newScrollPercentage) === INITIAL_SCROLL_PERCENTAGE ? 1 : currentFocusedSectionItem,
            currentFocusedSectionExact: currentScrollPosition / (slideOffset - widthOffset) + 1
        });
    });
}
function getShift(itemsContainerRef, showAutoRotation, slideOffset, columnShiftWidth) {
    var ref;
    var currentScrollPosition = itemsContainerRef === null || itemsContainerRef === void 0 ? void 0 : (ref = itemsContainerRef.current) === null || ref === void 0 ? void 0 : ref.scrollLeft;
    var shift = !showAutoRotation ? slideOffset : columnShiftWidth;
    var extraCoveredShift = Math.floor(currentScrollPosition % shift);
    var remainingShiftForward = shift - extraCoveredShift;
    var remainingShiftBackward = shift + extraCoveredShift;
    return {
        remainingShiftBackward: remainingShiftBackward,
        remainingShiftForward: Math.floor(remainingShiftForward) || shift + remainingShiftForward
    };
}
function getArrowMethods(itemsContainerRef, slideOffset, showAutoRotation, columnShiftWidth, columnGap, stopAutoRotation, startAutoRotation) {
    var onNextArrowClick = function onNextArrowClick() {
        var ref;
        var remainingShiftForward = getShift(itemsContainerRef, showAutoRotation, slideOffset, columnShiftWidth).remainingShiftForward;
        stopAutoRotation();
        (ref = itemsContainerRef.current) === null || ref === void 0 ? void 0 : ref.scrollBy({
            top: 0,
            left: remainingShiftForward,
            behavior: "smooth"
        });
        startAutoRotation();
    };
    var onPrevArrowClick = function onPrevArrowClick() {
        var ref;
        var remainingShiftBackward = getShift(itemsContainerRef, showAutoRotation, slideOffset, columnShiftWidth).remainingShiftBackward;
        stopAutoRotation();
        (ref = itemsContainerRef.current) === null || ref === void 0 ? void 0 : ref.scrollBy({
            top: 0,
            left: -remainingShiftBackward,
            behavior: "smooth"
        });
        startAutoRotation();
    };
    var carouselScrollTo = function carouselScrollTo(index) {
        var instantScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var ref;
        stopAutoRotation();
        (ref = itemsContainerRef.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
            left: columnShiftWidth * index,
            behavior: instantScroll ? "instant" : "smooth"
        });
        startAutoRotation();
    };
    return {
        onNextArrowClick: onNextArrowClick,
        onPrevArrowClick: onPrevArrowClick,
        carouselScrollTo: carouselScrollTo
    };
}
/* No padding is applied when carousel layout is chosen on mobile so scroll is from one screen edge
to another, so a margin is given on first & last element to give initial spacing before scroll starts **/ var getCardFrameCustomStyle = function(param) {
    var isLayoutCarousel = param.isLayoutCarousel, isMobile = param.isMobile, contentHorizontalPadding = param.contentHorizontalPadding, index = param.index, arr = param.arr;
    var margin = "";
    if (isLayoutCarousel && isMobile) {
        if (!index) margin = "0px 0px 0px ".concat(contentHorizontalPadding, "px");
        if (index === arr.length - 1) margin = "0px  ".concat(contentHorizontalPadding, "px 0px 0px");
    }
    return {
        margin: margin
    };
};
function getColumnGap(param) {
    var isMobile = param.isMobile, type = param.type, isLayoutTypeCard = param.isLayoutTypeCard, listPresentationConfig = param.listPresentationConfig, expandSelectedReel = param.expandSelectedReel;
    if (type === "icon" || type === "image") {
        return isMobile ? isLayoutTypeCard ? 8 : 16 : (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.columnGap) >= 0 ? listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.columnGap : 44;
    }
    if (type === "logoSlider") return isMobile ? !isLayoutTypeCard ? 16 : 10 : 20;
    if (type === "blog") return isMobile ? 10 : 32;
    if (type === "featuredReels" && expandSelectedReel) return isMobile ? 20 : 32;
    if (type === "testimonials") return isMobile ? !isLayoutTypeCard ? 16 : 12 : !isLayoutTypeCard ? 44 : 20;
    if (type === src_constants_widgets__WEBPACK_IMPORTED_MODULE_3__/* .ADMIN_WIDGETS_NAMES.GALLERY */ .G.GALLERY) return (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.rowColumnGap) >= 0 ? listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.rowColumnGap : 20;
    return isMobile ? 10 : 20;
}
function getRowGap(isMobile, type, isLayoutTypeCard, isTextNameBelow, isCollectionNameVisible, numColumns, listPresentationConfig) {
    if (type === "icon" || type === "image") return !isMobile ? 44 : isLayoutTypeCard ? 8 : 16;
    if (type === "logoSlider") return !isMobile ? 20 : !isLayoutTypeCard ? 20 : 10;
    if (type === "blog") return isMobile ? isLayoutTypeCard ? 10 : 24 : 32;
    if (type === "testimonials") return isMobile ? !isLayoutTypeCard ? 44 : 12 : !isLayoutTypeCard ? 64 : 20;
    if (type === src_constants_widgets__WEBPACK_IMPORTED_MODULE_3__/* .ADMIN_WIDGETS_NAMES.GALLERY */ .G.GALLERY) return (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.rowColumnGap) >= 0 ? listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.rowColumnGap : 20;
    return !isMobile ? isTextNameBelow && isCollectionNameVisible ? 40 : 20 : isTextNameBelow && isCollectionNameVisible ? 36 : 10;
}
var getGridGapsForAxes = function(param) {
    var isMobile = param.isMobile, cardFrameConfig = param.cardFrameConfig, listPresentationConfig = param.listPresentationConfig, type = param.type, isLayoutTypeCard = param.isLayoutTypeCard, expandSelectedReel = param.expandSelectedReel, numColumns = param.numColumns;
    var ref = (0,_CardFrameCollection_utils__WEBPACK_IMPORTED_MODULE_1__/* .getCardConfigurations */ .JH)(cardFrameConfig), isTextNameBelow = ref.isTextNameBelow, isCollectionNameVisible = ref.isCollectionNameVisible;
    return {
        columnGap: getColumnGap({
            isMobile: isMobile,
            type: type,
            isLayoutTypeCard: isLayoutTypeCard,
            listPresentationConfig: listPresentationConfig,
            expandSelectedReel: expandSelectedReel
        }),
        rowGap: getRowGap(isMobile, type, isLayoutTypeCard, isTextNameBelow, isCollectionNameVisible, numColumns, listPresentationConfig)
    };
};
var getReelCardConfigs = function(config) {
    var isCardLayout = (config === null || config === void 0 ? void 0 : config.appearance) === "card";
    var isFullWidth = isCardLayout && (config === null || config === void 0 ? void 0 : config.imageWidth) === "fullWidth";
    var style = {
        background: isCardLayout ? config === null || config === void 0 ? void 0 : config.backgroundColor : "transparent",
        borderColor: isCardLayout ? config === null || config === void 0 ? void 0 : config.borderColor : "#111C361F"
    };
    var className = isCardLayout ? "tw-border-[1px] tw-border-solid" : "";
    return {
        style: style,
        className: className,
        isCardLayout: isCardLayout,
        isFullWidth: isFullWidth
    };
};
function isLogoSliderAutoScroll(param) {
    var cardFrameConfig = param.cardFrameConfig, listPresentationConfig = param.listPresentationConfig;
    return (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.autoScroll) && (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutType) === "carousel";
}
function isLogoSliderFullWidth(param) {
    var cardFrameConfig = param.cardFrameConfig, listPresentationConfig = param.listPresentationConfig;
    return (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.scrollFullWidth) && (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.autoScroll) && (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutType) === "carousel";
}
function isTestimonialSliderFullWidth(param) {
    var listPresentationConfig = param.listPresentationConfig;
    var ref;
    var isTestimonial = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === "testimonials";
    var isAutoScroll = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.autoPlayConfig) === null || ref === void 0 ? void 0 : ref.type) === _components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_2__/* .SCROLL_TYPE.AUTO_SCROLL */ .ej.AUTO_SCROLL;
    return isTestimonial && isAutoScroll;
}
var getRenderCardOverrides = function(param) {
    var listPresentationConfig = param.listPresentationConfig, sectionColors = param.sectionColors;
    var ref, ref1, ref2, ref3;
    if (!(listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.defaultOverrides) === null || ref1 === void 0 ? void 0 : ref1.isEnabled)) {
        return "";
    }
    switch(listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref2 = listPresentationConfig.colors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.defaultOverrides) === null || ref3 === void 0 ? void 0 : ref3.colorSchemeName){
        case "custom":
            return sectionColors === null || sectionColors === void 0 ? void 0 : sectionColors.text;
        case "white":
            return "#ffffff";
        default:
            return "";
    }
};
function getBlogData(blogList) {
    var simplifiedBlogData = blogList === null || blogList === void 0 ? void 0 : blogList.map(function(data) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        return {
            imageDetail: {
                url: (data === null || data === void 0 ? void 0 : (ref = data.image) === null || ref === void 0 ? void 0 : ref.url) || ""
            },
            title: (data === null || data === void 0 ? void 0 : (ref1 = data.heading) === null || ref1 === void 0 ? void 0 : ref1.display_text) || "",
            description: (data === null || data === void 0 ? void 0 : (ref2 = data.description) === null || ref2 === void 0 ? void 0 : ref2.display_text) || "",
            date: (data === null || data === void 0 ? void 0 : (ref3 = data.date) === null || ref3 === void 0 ? void 0 : ref3.selected_date) + " " + (data === null || data === void 0 ? void 0 : (ref4 = data.date) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.selected_month) === null || ref5 === void 0 ? void 0 : ref5.slice(0, 3)) || ""
        };
    });
    return simplifiedBlogData;
}


/***/ })

}]);